import React from 'react';
import createSvgIcon from '../utils/createSvg';
export default createSvgIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M145 285c77.3 0 140-62.7 140-140S222.3 5 145 5 5 67.7 5 145s62.7 140 140 140zm61.6-140l-100.8 50.4V94.6L206.6 145z"
})), 'PlayAltFilledIcon');